import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './reset.css';
import './cores.css';
import reportWebVitals from './reportWebVitals';
import AppRoutes from './routes';
import { AuthProvider } from './contextos/AuthContext';
import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3';
    

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
  <React.StrictMode>  {/*monitora qualidade do código*/} 
    <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}> {/*fornece o contexto do reCAPTCHA para toda a aplicação */}
      <AuthProvider>    {/*fornece o contexto de autenticação para toda a aplicação */}
          <AppRoutes />
      </AuthProvider>
    </GoogleReCaptchaProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
